// React
import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Shared
import { withTranslation } from 'shared/utils/withTranslation'
import { setFilterSearchQuery } from 'store/v2/redux/actions/filter'
import useIsMobile from 'shared/utils/useIsMobile'

const ProductSearch = ({ t, filterKey = 'global' }) => {
  const ref = useRef(null)

  const [value, setValue] = useState('')

  const isMobile = useIsMobile()

  const handleInputChange = (e) => {
    setValue(e.target.value)

    // Search was cleared manually
    if (e.target.value === '') {
      setFilterSearchQuery('', filterKey)
    }
  }

  const handleInputKeyUp = (e) => {
    if (e.key === 'Enter') {
      setFilterSearchQuery(value, filterKey)

      if (isMobile) {
        ref.current?.blur()
      }
    }
  }

  const handleClearClick = () => {
    setValue('')

    setFilterSearchQuery('', filterKey)

    ref.current?.focus()
  }

  return (
    <div className="bq-product-search-component">
      <div className="bq-button bq-branded bq-product-search-icon">
        <i className="bq-icon-search fas fa-search bq-branded-font-color" />
      </div>
      <input
        type="search"
        className="bq-product-search-input bq-branded-focus"
        placeholder={t('user.store.search_products')}
        ref={ref}
        value={value}
        onChange={handleInputChange}
        onKeyUp={handleInputKeyUp}
      />
      {value && (
        <div className="bq-product-search-clear" onClick={handleClearClick}>
          <i className="bq-icon-cross fas fa-times" />
        </div>
      )}
    </div>
  )
}

ProductSearch.displayName = 'ProductSearch'

ProductSearch.propTypes = {
  t: PropTypes.func,
  filterKey: PropTypes.string
}

const mapStateToProps = (_state, props) => {
  return {
    filterKey: props.searchKey || props.filterKey
  }
}

const decoratedComponent = reduxConnect(mapStateToProps)(ProductSearch)

export default withTranslation('user')(decoratedComponent)
